import { defineStore } from 'pinia'
import { actions, getters, state } from './ext/items.js'
import axios from 'axios'


export const useFundraiserPageStore = defineStore('fundraiserPage', {
  id: 'fundraiserPage',
  state: () => ({
    ...state(),
    api: '/api/v1/fundraiser-pages',

  }),
  getters: {
    ...getters,
    getItemsByFundraiserId: (state) => (fundraiserId) => {
      return state.items.filter(item => item.fundraiser_id === fundraiserId)
    }
  },
  actions: {
    ...actions,
    async fundraiserPageSlideShowPatch(payload) {
      const { data } = await axios.post(`${this.api}/${payload.id}/slideshow`, payload)
      this.itemPatchState(data)
      return data
    },
    async fundraiserPageDetailsPatch(fundraiserPageId, payload) {
      const { data } = await axios.post(`${this.api}/${fundraiserPageId}/details`, payload)
      this.itemPatchState(data)
      return data
    },
    async fundraiserPageCustomFieldsPatch(fundraiserPageId, payload) {
      const { data } = await axios.post(`${this.api}/${fundraiserPageId}/custom-fields`, payload)
      this.itemPatchState(data)
      return data
    },
    async fundraiserPageValidateSlug(fundraiserPageId, payload) {
      const { data } = await axios.post(`${this.api}/${fundraiserPageId}/validate-slug`, payload)
      return data
    },
    async fundraiserPagePublish(fundraiserPageId) {
      const { data } = await axios.post(`${this.api}/${fundraiserPageId}/publish`)
      this.itemPatchState(data)
      return data
    },
    async fundraiserPageUnPublish(fundraiserPageId) {
      const { data } = await axios.post(`${this.api}/${fundraiserPageId}/unpublish`)
      this.itemPatchState(data)
      return data
    },
    async fundraiserPageMarkAsFeatured(fundraiserPageId) {
      const { data } = await axios.post(`${this.api}/${fundraiserPageId}/mark-as-featured`)
      this.itemPatchState(data)
      return data
    },
    async fundraiserPageMarkAsNotFeatured(fundraiserPageId) {
      const { data } = await axios.post(`${this.api}/${fundraiserPageId}/mark-as-not-featured`)
      this.itemPatchState(data)
      return data
    },
    async fetchDashboardReport(fundraiserPageId, params) {
      const { data } = await axios.get(`/api/v1/fundraiser-pages/${fundraiserPageId}/dashboard-report`, {
        params: params
      })
      return data
    },
    async autologinAsFundraiserPage(fundraiserPageId) {
      const { data } = await axios.post(`/api/v1/fundraiser-pages/${fundraiserPageId}/autologin-token`)
      return data.token
    },
    async createEmailCampaignDripFeed(fundraiserPageId) {
      const { data } = await axios.post(`/api/v1/fundraiser-pages/${fundraiserPageId}/create-email-campaign-drip-feed`)
      this.itemPatchState(data)
      return data
    },
    async fundraiserPageCommunicationPatch(fundraiserPageId, payload) {
      const { data } = await axios.post(`/api/v1/fundraiser-pages/${fundraiserPageId}/communication`, payload)
      this.itemPatchState(data)
      return data
    },
    async fundraiserPageSettingsPatch(fundraiserPageId, payload) {
      const { data } = await axios.post(`/api/v1/fundraiser-pages/${fundraiserPageId}/settings`, payload)
      this.itemPatchState(data)
      return data
    },
    async fundraiserPageDisableEmailCampaignDripFeed(fundraiserPageId) {
      const { data } = await axios.post(`/api/v1/fundraiser-pages/${fundraiserPageId}/disable-email-campaign-drip-feed`)
      this.itemPatchState(data)
      return data
    },
    async resetPassword(fundraiserPageId, newPassword) {
      const { data } = await axios.post(`/api/v1/fundraiser-pages/${fundraiserPageId}/reset-password`,{
        new_password: newPassword
      })
      this.itemPatchState(data)
      return data
    },
    async rebuildCache(fundraiserPageId) {
      const { data } = await axios.post(`/api/v1/fundraiser-pages/${fundraiserPageId}/rebuild-cache`)
      this.itemPatchState(data)
      return data
    }
  }
})
